import { format } from 'date-fns';

import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';

type Props = {
  narrative: Narrative;
};

export const NarrativeTimestamp = ({ narrative }: Props) => {
  const { createdAt, updatedAt } = narrative;
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2">
        <div className="text-tiny text-soft">Published</div>
        <div className="whitespace-nowrap text-tiny text-solid">
          {format(new Date(createdAt), 'dd MMM yy')}
        </div>
      </div>
      {updatedAt && (
        <div className="flex items-center gap-2">
          <div className="text-tiny text-soft">Updated</div>
          <div className="whitespace-nowrap text-tiny text-solid">
            {format(new Date(updatedAt), 'dd MMM yy')}
          </div>
        </div>
      )}
    </div>
  );
};
